import React, { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    useNavigate,
  } from 'react-router-dom';
import ChatbotPage from './pages/chatbot_page';
import LoginPage from './pages/login_page';

// Function to check if the user is logged in
const isAuthenticated = () => {
    return localStorage.getItem('authToken') !== null;
  };

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const isLoggedIn = isAuthenticated();
  
    useEffect(() => {
      if (!isLoggedIn) {
        navigate('/login');
      }
    }, [isLoggedIn, navigate]);
  
    return isLoggedIn ? children : null;
  };

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/chatbot" element={<ProtectedRoute><ChatbotPage /></ProtectedRoute>} /> {}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<LoginPage />} />
        {/* Add other routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;